import React, { useEffect, useState } from "react";
import Sidebar from "../Sidebar/Sidebar";
import Navbar from "./Navbar";
import Header from "./header";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import ApiConfig from "../../common/config/ApiConfig";
import LottoWaitResultType from "./lottowaitresulttype";
import { useLanguage } from "../../common/i18n/LanguageContext";

const LIMIT = 10;

function LottoWaitResultTypePage() {
  const { t } = useLanguage();
  const pos = localStorage.getItem("position");
  const user = localStorage.getItem("user");

  const [seniorOptions, setSeniorOptions] = useState([]);
  const [masterOptions, setMasterOptions] = useState([]);
  const [agentOptions, setAgentOptions] = useState([]);

  const [selectedSenior, setSelectedSenior] = useState("");
  const [selectedMaster, setSelectedMaster] = useState("");
  const [selectedAgent, setSelectedAgent] = useState("");

  const [date, setDate] = useState(moment().format("YYYY-MM-DD"));
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);

  const fetchDownline = (username, setOptions) => {
    ApiConfig.get(
      `/getdownline?user=${encodeURIComponent(username)}`,
    ).then((result) => {
      if (result.resCode !== 200) {
        toast.error(result.message || t("common_load_error"), {
          position: "top-right",
          autoClose: 3000,
        });
        return;
      }
      const list = Array.isArray(result.data) ? result.data : [];
      const uniqueByUsername = Array.from(
        new Map(list.map((item) => [item.username, item])).values(),
      );
      setOptions(uniqueByUsername);
    });
  };

  useEffect(() => {
    fetchDownline(user, setSeniorOptions);
    fetchData(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSelectSenior = (value) => {
    setSelectedSenior(value);
    setSelectedMaster("");
    setSelectedAgent("");
    setMasterOptions([]);
    setAgentOptions([]);
    if (value) fetchDownline(value, setMasterOptions);
  };

  const handleSelectMaster = (value) => {
    setSelectedMaster(value);
    setSelectedAgent("");
    setAgentOptions([]);
    if (value) fetchDownline(value, setAgentOptions);
  };

  const fetchData = (currentPage = 1) => {
    const params = new URLSearchParams({
      user,
      senior: selectedSenior,
      master: selectedMaster,
      agent: selectedAgent,
      date,
      page: currentPage,
      limit: LIMIT,
    });
    ApiConfig.get(`/getOutStandingByType?${params.toString()}`).then(
      (result) => {
        if (result.resCode !== 200) {
          toast.error(result.message || t("common_load_error"), {
            position: "top-right",
            autoClose: 3000,
          });
          return;
        }
        setData(Array.isArray(result.data) ? result.data : []);
        setPage(currentPage);
        if (result.total != null) setTotal(result.total);
      },
    );
  };

  const totalPages = total > 0 ? Math.ceil(total / LIMIT) : 0;

  return (
    <div className="h-screen flex flex-col overflow-hidden">
      <div className="shrink-0">
        <Navbar />
      </div>
      <div className="flex flex-1 overflow-hidden items-start">
        <div className="shrink-0 overflow-y-auto h-full">
          <Sidebar pos={pos} />
        </div>
        <div className="flex flex-col flex-1 max-h-full overflow-hidden">
          <div className="shrink-0">
            <Header title={t("menu_outstanding_type")} />
          </div>
          <div className="flex-1 overflow-y-auto p-2">
            <div className="p-2 bg-amber-50 border-[1px] border-slate-400 rounded-lg mb-2 text-sm">
              <div className="flex flex-row flex-wrap items-center gap-4">
                <div className="flex flex-row items-center gap-2">
                  <label className="font-bold">
                    {t("winlose_col_senior")}
                  </label>
                  <select
                    value={selectedSenior}
                    onChange={(e) => handleSelectSenior(e.target.value)}
                    className="p-1 border border-gray-300 rounded"
                  >
                    <option value="">{t("common_all")}</option>
                    {seniorOptions.map((opt) => (
                      <option key={opt.username} value={opt.username}>
                        {opt.username}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="flex flex-row items-center gap-2">
                  <label className="font-bold">
                    {t("winlose_col_master")}
                  </label>
                  <select
                    value={selectedMaster}
                    onChange={(e) => handleSelectMaster(e.target.value)}
                    disabled={!selectedSenior}
                    className="p-1 border border-gray-300 rounded disabled:bg-gray-100"
                  >
                    <option value="">{t("common_all")}</option>
                    {masterOptions.map((opt) => (
                      <option key={opt.username} value={opt.username}>
                        {opt.username}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="flex flex-row items-center gap-2">
                  <label className="font-bold">
                    {t("winlose_col_agent")}
                  </label>
                  <select
                    value={selectedAgent}
                    onChange={(e) => setSelectedAgent(e.target.value)}
                    disabled={!selectedMaster}
                    className="p-1 border border-gray-300 rounded disabled:bg-gray-100"
                  >
                    <option value="">{t("common_all")}</option>
                    {agentOptions.map((opt) => (
                      <option key={opt.username} value={opt.username}>
                        {opt.username}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="flex flex-row items-center gap-2">
                  <label className="font-bold">
                    {t("common_date_label")}
                  </label>
                  <input
                    type="date"
                    value={date}
                    onChange={(e) => setDate(e.target.value)}
                    className="p-1 border border-gray-300 rounded"
                  />
                </div>

                <button
                  onClick={() => fetchData(1)}
                  className="py-1 px-3 bg-brand-blue-700 hover:bg-brand-blue-800 text-white font-bold rounded text-sm"
                >
                  {t("common_search")}
                </button>
              </div>
            </div>

            <LottoWaitResultType data={data} />

            {(totalPages > 1 || data.length > 0) && (
              <div className="flex items-center justify-between mt-3 px-2">
                <span className="text-sm font-semibold text-brand-blue-700 bg-brand-blue-50 px-3 py-1 rounded-full border border-brand-blue-200">
                  {t("commission_page_label")} {page}
                  {totalPages > 0 ? ` / ${totalPages}` : ""}
                  {total > 0 && ` · ${total} ${t("common_items_unit")}`}
                </span>
                <div className="flex space-x-1">
                  <button
                    onClick={() => fetchData(1)}
                    disabled={page === 1}
                    className="px-2 py-1 text-sm font-bold rounded bg-gray-200 text-gray-700 hover:bg-gray-300 disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
                  >
                    «
                  </button>
                  <button
                    onClick={() => fetchData(Math.max(1, page - 1))}
                    disabled={page === 1}
                    className="px-3 py-1 text-sm font-medium rounded bg-brand-blue-100 text-brand-blue-700 hover:bg-brand-blue-200 disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
                  >
                    ‹ {t("common_page_previous")}
                  </button>
                  <span className="px-3 py-1 text-sm font-bold rounded bg-brand-blue-600 text-white select-none">
                    {page}
                  </span>
                  <button
                    onClick={() => fetchData(page + 1)}
                    disabled={totalPages > 0 && page >= totalPages}
                    className="px-3 py-1 text-sm font-medium rounded bg-brand-blue-100 text-brand-blue-700 hover:bg-brand-blue-200 disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
                  >
                    {t("common_next")} ›
                  </button>
                  {totalPages > 0 && (
                    <button
                      onClick={() => fetchData(totalPages)}
                      disabled={page >= totalPages}
                      className="px-2 py-1 text-sm font-bold rounded bg-gray-200 text-gray-700 hover:bg-gray-300 disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
                    >
                      »
                    </button>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default LottoWaitResultTypePage;
